'use client';

import { RectangleButton } from '@yanolja-rnd/nol-design-system';
import { IcArrowlessFill, IcArrowmoreFill } from '@yanolja-rnd/nol-icons';

interface MoreButtonProps {
  isFold: boolean;
  setIsFold: (isFold: boolean) => void;
  onClick?: () => void;
}

export const MoreButton: React.FC<MoreButtonProps> = ({ isFold, setIsFold, onClick }) => {
  return (
    <RectangleButton
      className="mt-16"
      type="button"
      theme="outlined_basic"
      size="medium"
      weight="regular"
      fullWidth
      onClick={() => {
        onClick?.();
        setIsFold(!isFold);
      }}>
      <div className="flex items-center gap-2">
        {isFold ? (
          <>
            더보기
            <IcArrowmoreFill height={16} width={16} />
          </>
        ) : (
          <>
            접기
            <IcArrowlessFill height={16} width={16} />
          </>
        )}
      </div>
    </RectangleButton>
  );
};
